import { useMutation } from 'react-query';
import { getInputLinksByStage } from '../index';
export const useGetInputLinksByStage = (callback) => useMutation(getInputLinksByStage, {
    onSuccess: () => {
        if (callback && typeof callback === 'function') {
            callback();
        }
    }
});
